// src/constants/colors.js
// Define colors for light and dark mode
const COLORS = {
    primary: '#2D4A3D', // Dark Green (Main UI color)
    secondary: '#6B8F71', // Light Green (Soft UI elements)
    accent: '#F8B400', // Golden Yellow (Call-to-action buttons, highlights)
    text: 'rgba(51, 51, 51, 0.8)', // Improved text contrast
    white: '#FFFFFF', // White for backgrounds
    background: '#EAEDED', // Light Grey for backgrounds and cards
    danger: '#D9534F', // Red for error messages and warnings
  border: '#E1E1E1',        // Light gray for borders

};

export default COLORS;
